import React, {Suspense, useState} from 'react';

import PillComponent from '../../pillComponent/pillComponent';
import ToolTipComponent from '../../toolTipComponent';

import './buttonComponentV2.css';

const ButtonComponentV2 = ({
  isSelected = false,
  Icon = null,
  pillType = null,
  RightIcon = null,
  btnText = '',
  toolTipTxt = '',
  toolTipPosition = 'bottom',
  onClick = () => {},
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`et-v2-button-component-container ${
        isSelected ? 'et-v2-button-component-selected' : ''
      } ${Icon ? 'et-v2-button-with-icon' : ''}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {Icon && (
        <div className="et-v2-button-component-icon-wrap">
          <Suspense fallback={null}>
            <Icon fillColor={isSelected ? '#2961FA' : '#2D2756'} />
          </Suspense>
        </div>
      )}
      {Icon && btnText && <div className="et-v2-btn-icon-txt-separator" />}
      {btnText && (
        <div
          className={`et-v2-button-text ${
            Icon ? '' : 'et-v2-button-text-center'
          }`}>
          {btnText}
        </div>
      )}
      {pillType && <PillComponent pillType={pillType} />}
      {RightIcon && (
        <div className="et-v2-btn-comp-right-icon-wrap">
          {/* <div className="et-v2-btn-icon-txt-separator" /> */}
          <Suspense fallback={null}>
            <RightIcon />
          </Suspense>
        </div>
      )}
      {toolTipTxt && isHovered && (
        <ToolTipComponent
          toolTipTxt={toolTipTxt}
          toolTipPosition={toolTipPosition}
        />
      )}
    </div>
  );
};

export default ButtonComponentV2;
